export default __webpack_public_path__ + "img/pin_icons/pull_station_w.svg";